export default __webpack_public_path__ + "static/media/image-inside-macbook.971fc5e0.png";